import { getApiUrl } from '@/config/api';

export async function removeTeamMember(teamId: number, userId: number): Promise<void> {
  const token = localStorage.getItem('access');
  const res = await fetch(getApiUrl(`/api/teams/teams/${teamId}/remove-member/`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ user_id: userId }),
  });
  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
    const detail = data.detail;
    const detailStr =
      typeof detail === 'string' ? detail : detail != null ? JSON.stringify(detail) : undefined;
    const errStr = typeof data.error === 'string' ? data.error : undefined;
    throw new Error(errStr || detailStr || `Failed to remove member (${res.status})`);
  }
}
